import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { environment } from '../../../environments/environment';

import { BaseComponent } from '../base/base.component';

import { ClientService } from '../../services/client.service';
import { ClientStyleService } from '../../services/client-style.service';
import { InvoiceService } from '../../services/invoice.service';
import { OpenEdgeService } from '../../services/open-edge.service';
import { MessageService } from '../../services/message.service';
import { InvoiceModel, InvoiceItemModel, OrderModel, OrderItemModel, Activity
		, ProviderResponseModel_MonerisCA
		, ProviderResponseModel_MonerisCheckout
		, ProviderResponseModel_MonerisUS
		, ProviderResponseModel_ChaseUS
		, ProviderResponseModel_ChaseCA
		, ProviderResponseModel_AuthNetUS
		, ProviderResponseModel_AuthNetCA
		, ProviderResponseModel_Elavon
		, ProviderResponseModel_OpenEdge
		, ProviderResponseModel_GlobalPayments
		, ProviderResponseModel_E_Xact
		, ProviderAuthResponseModel_Heartland
		, ProviderResponseModel_Velocity	
		, ProviderResponseModel_CyberSource
} from '../../models/invoice.model';
import { TransactionStatusEnum } from '../../models/lookups.enum';

@Component({
	selector: 'invoice-clearing',
	templateUrl: './clearing.component.html',
	styleUrls: ['./clearing.component.css']
})
export class ClearingComponent extends BaseComponent implements OnInit {

	public paymentAccepted: boolean;
	public retryKey: string;
	public responseJson: any;
	public responseString: string;
	public hasError: boolean = false;
	public isProcessed: boolean = false;
	public stillHasError: boolean = false;
	public invoiceInvalid: boolean = false;
	public errorTracerId: number;
	public activeInvoice: InvoiceModel;
	public orderModel: OrderModel = new OrderModel();
	private monerisCAResponse: ProviderResponseModel_MonerisCA = null;
	private monerisCheckoutResponse: ProviderResponseModel_MonerisCheckout = null;
	private monerisUSResponse: ProviderResponseModel_MonerisUS = null;
	private elavonResponse: ProviderResponseModel_Elavon = null;
	private openEdgeResponse: ProviderResponseModel_OpenEdge = null;
	private chaseUSResponse: ProviderResponseModel_ChaseUS = null;
	private chaseCAResponse: ProviderResponseModel_ChaseCA = null;
	private authNetUSResponse: ProviderResponseModel_AuthNetUS = null;
	private globalPaymentsResponse : ProviderResponseModel_GlobalPayments = null;
	private e_XactResponse : ProviderResponseModel_E_Xact = null;
	private heartlandResponse: ProviderAuthResponseModel_Heartland = null;
	private velocityResponse : ProviderResponseModel_Velocity = null;
	private cyberSourceResponse : ProviderResponseModel_CyberSource = null;
	private transactionStatusEnum: TransactionStatusEnum = new TransactionStatusEnum();
	private retryCount: number = 0;
	private retryLimit: number = 5;

	constructor(public router: Router, public route: ActivatedRoute, public messageService: MessageService, private _titleService: Title, public clientService: ClientService, public clientStyleService: ClientStyleService, private _invoiceService: InvoiceService, private _openEdgeService: OpenEdgeService) {
		super(router, route, messageService, clientService, clientStyleService);
		this._titleService.setTitle('Citations - Payment Clearing');
		this.messageService.isBusy = true;
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.dealWithProcessorResponse();
	}

	public getSearchKey() {
		return this.retryKey;
	}

	public reload() {
		this.messageService.clearAppError();
		window.location.reload();
	}

	public dealWithProcessorResponse() {
		this.messageService.clearAppError();
		this.messageService.isBusy = true;
		this.isProcessed = false;
		this.responseJson = {};

		this.route.params.forEach((params: Params) => {
			for (var param in params) {
				this.responseJson[param] = params[param];
			}
		});

		this.route.queryParams.forEach((params : Params) => {
			for (var param in params) {
				this.responseJson[param] = this._invoiceService.cleanseUrlParam(params[param]);
			}
		});
		this.responseString = JSON.stringify(this.responseJson, null, '\t');
		if ('mcoClientKey' in this.responseJson && 'mcoProcName' in this.responseJson && this.responseJson['mcoProcName'] == 'monerischeckout') {
			this.monerisCheckoutResponse = new ProviderResponseModel_MonerisCheckout();
			this.monerisCheckoutResponse = this.responseJson;
			this.monerisCheckoutResponse.appKey = environment.appToken;
			this.clientService.loadClientByKey(this.monerisCheckoutResponse.mcoClientKey);
			this.clientStyleService.loadClientBranding(this.monerisCheckoutResponse.mcoClientKey);
			this.getResponseInvoice(this.monerisCheckoutResponse.mcoInvoiceId, this.monerisCheckoutResponse.mcoInvoiceNumber, this.monerisCheckoutResponse.charge_total);
			this.retryKey = this.monerisCheckoutResponse.mcoInvoiceNumber;
		} else if (('rvarclientKey' in this.responseJson) && ('rvarprocName' in this.responseJson) && this.responseJson['rvarprocName'] == 'monerisca') {
			this.monerisCAResponse = new ProviderResponseModel_MonerisCA();
			this.monerisCAResponse = this.responseJson;
			this.clientService.loadClientByKey(this.monerisCAResponse.rvarclientKey);
			this.clientStyleService.loadClientBranding(this.monerisCAResponse.rvarclientKey);
			this.getResponseInvoice(this.monerisCAResponse.rvarinvoiceId, this.monerisCAResponse.rvarinvoiceNumber, this.monerisCAResponse.charge_total);
			this.retryKey = this.monerisCAResponse.rvarinvoiceNumber;
		} else if ('rvarclientKey' in this.responseJson && 'rvarprocName' in this.responseJson && this.responseJson['rvarprocName'] == 'monerisus') {
			this.monerisUSResponse = new ProviderResponseModel_MonerisUS();
			this.monerisUSResponse = this.responseJson;
			this.clientService.loadClientByKey(this.monerisUSResponse.rvarclientKey);
			this.clientStyleService.loadClientBranding(this.monerisUSResponse.rvarclientKey);
			this.getResponseInvoice(this.monerisUSResponse.rvarinvoiceId, this.monerisUSResponse.rvarinvoiceNumber, this.monerisUSResponse.amount);
			this.retryKey = this.monerisUSResponse.rvarinvoiceNumber;
		} else if (('ssl_txn_id' in this.responseJson) && ('ssl_invoice_number' in this.responseJson) && this.responseJson['ssl_description'] == 'elavon') {
			this.elavonResponse = new ProviderResponseModel_Elavon();
			this.elavonResponse = this.responseJson;
			this.clientService.loadClientByKey(this.elavonResponse.ven_client_key);
			this.clientStyleService.loadClientBranding(this.elavonResponse.ven_client_key);
			this.getResponseInvoice(this.elavonResponse.ven_order_key, this.elavonResponse.ssl_invoice_number, this.elavonResponse.ssl_amount);
			this.retryKey = this.elavonResponse.ven_order_key;
		/*****************************   Auth.Net URL Validation bug   ********** Workaround ***********************/
		} else if (('ok' in this.responseJson) || ('kncl' in this.responseJson)) {
			this.authNetUSResponse = new ProviderResponseModel_AuthNetUS();
			this.authNetUSResponse = this.responseJson;
			this.authNetUSResponse.cancelTxn = this.responseJson['kncl'] !== undefined && this.responseJson['kncl'] != null && this.responseJson['kncl'] != '';
			this.authNetUSResponse.ok = this.responseJson['ok'] ? this.responseJson['ok'] : this.responseJson['kncl'];
			this.getResponseInvoice(this.authNetUSResponse.ok, this.authNetUSResponse.on, this.authNetUSResponse.amount);
			this.retryKey = this.authNetUSResponse.ok;
		/*****************************   Auth.Net URL Validation bug   ********** Original *************************
		} else if ('ck' in this.responseJson && 'ok' in this.responseJson && this.responseJson['procname'] == 'authorizenet') {
			this.authNetUSResponse = new ProviderResponseModel_AuthNetUS();
			this.authNetUSResponse = this.responseJson;
			this.authNetUSResponse.cancelTxn = this.responseJson['cancelTxn'] == 'true';
			this.clientService.loadClientByKey(this.authNetUSResponse.ck);
			this.getResponseInvoice(this.authNetUSResponse.ok, this.authNetUSResponse.on, this.authNetUSResponse.amount);
			this.retryKey = this.authNetUSResponse.ok;
		***********************************************************************************************************/
		} else if (('response_code' in this.responseJson) && ('secondary_response_code' in this.responseJson)) {
			this.openEdgeResponse = new ProviderResponseModel_OpenEdge();
			this.openEdgeResponse = this.responseJson;
			this.openEdgeResponse.appKey = environment.appToken;
			this.getOpenEdgeOrder(this.openEdgeResponse.order_id);
			this.retryKey = this.openEdgeResponse.order_id;
		} else if ('uID' in this.responseJson){
			this.chaseUSResponse = new ProviderResponseModel_ChaseUS();
			this.chaseUSResponse = this.responseJson;
			this.chaseUSResponse.appKey = environment.appToken;
			this.getResponseInvoice(this.chaseUSResponse.order_key, this.chaseUSResponse.uID, null);
			this.retryKey = this.chaseUSResponse.order_key;
		} else if (('ORDER_ID' in this.responseJson) && ('MERCHANT_ID' in this.responseJson)){
			this.globalPaymentsResponse = new ProviderResponseModel_GlobalPayments();
			this.globalPaymentsResponse = this.responseJson;
			this.globalPaymentsResponse.appKey = environment.appToken;
			this.clientService.loadClientByKey(this.globalPaymentsResponse.CLIENT_KEY);
			this.getResponseInvoice(this.globalPaymentsResponse.ORDER_KEY, this.globalPaymentsResponse.ORDER_ID, +this.globalPaymentsResponse.AMOUNT / 100.00);
			this.retryKey = this.globalPaymentsResponse.ORDER_KEY;
		} else if (('x_reference_3' in this.responseJson) && ('order_key' in this.responseJson)){
			this.e_XactResponse = new ProviderResponseModel_E_Xact();
			this.e_XactResponse = this.responseJson;
			this.e_XactResponse.appKey = environment.appToken;
			this.clientService.loadClientByKey(this.e_XactResponse.x_cust_id);
			this.getResponseInvoice(this.e_XactResponse.order_key, this.e_XactResponse.Customer_Ref + '-' + this.e_XactResponse.Reference_No, +this.e_XactResponse.x_amount);
			this.retryKey = this.e_XactResponse.order_key;
		} else if (('transientToken' in this.responseJson) && ('orderKey' in this.responseJson)) {
			this.cyberSourceResponse = new ProviderResponseModel_CyberSource();
			this.cyberSourceResponse = this.responseJson;
			this.cyberSourceResponse.appKey = environment.appToken;
			this.clientService.loadClientByKey(this.cyberSourceResponse.clientKey);
			this.getResponseInvoice(this.cyberSourceResponse.orderKey, this.cyberSourceResponse.orderNumber, +this.cyberSourceResponse.orderAmount);
			this.retryKey = this.cyberSourceResponse.orderKey;
		} else if (
			(('cancelTXN' in this.responseJson) && (this.responseJson['cancelTXN'] == 'Cancel+Transaction' || this.responseJson['cancelTXN'] == 'Cancel%20Transaction' || this.responseJson['cancelTXN'] == 'Cancel Transaction')) 
			|| (('cancel' in this.responseJson) && (this.responseJson['cancel'] == 'Cancel+Transaction' || this.responseJson['cancel'] == 'Cancel%20Transaction' || this.responseJson['cancel'] == 'Cancel Transaction')) 
			|| (('cancelTxn' in this.responseJson) && this.responseJson['cancelTxn'] == 'true')) {
			this.messageService.isBusy = false;
			this.router.navigate(['/pay-items', { cancel: 'cancelled' }]);
		} else if (('remittance_id' in this.responseJson) && ('security_id' in this.responseJson)){
			this.velocityResponse = new ProviderResponseModel_Velocity();
			this.velocityResponse = this.responseJson;
			this._invoiceService.getVelocityOrder(this.velocityResponse.remittance_id, this.velocityResponse.security_id)
			.then(response => {
				if(response != null){
					this.orderModel = response;
					this.router.navigate(['/pay-items', {key: response.orderKey, invNum: response.orderRefNumber, retryKey: response.orderKey}]);
				}else{
					this.isProcessed = true;
					this.hasError = true;
				}
			}).catch(error => {
				this.isProcessed = true;
				this.hasError = true;
				this.logFailedRequest(error);
				this.messageService.showAppError('Error!', error);
			});
		} else if (('continue_processing' in this.responseJson)){
			this.isProcessed = true;
			this.invoiceInvalid = true;
			this.activeInvoice = new InvoiceModel();
			this.messageService.showAppAlert('Error!', 'Sorry, this payment could not be processed. Do you want to retry?');
		} else {
			this.messageService.showAppError('Error!', 'Sorry, this payment could not be processed. Please retain the invoice number, bank approval code, and date and time of transaction from the data below.');
			this.hasError = true;
			this.activeInvoice = new InvoiceModel();
			this.logFailedRequest('Unable to identify client from transaction');
		}

		if(this.retryCount >= this.retryLimit){
			this.stillHasError = true;
		}
		this.retryCount++;
	}

	private updateInvoice(data: any){
		this.activeInvoice = data;
		this.activeInvoice.invoiceNumberLong = this.orderModel.orderRefNumberLong;
		this.paymentAccepted = null;
		this.isProcessed = false;

		this.activeInvoice.monerisCAResponse = this.monerisCAResponse;
		this.activeInvoice.monerisCheckoutResponse = this.monerisCheckoutResponse;
		this.activeInvoice.monerisUSResponse = this.monerisUSResponse;
		this.activeInvoice.elavonResponse = this.elavonResponse;
		this.activeInvoice.openEdgeResponse = this.openEdgeResponse;
		this.activeInvoice.chaseUSResponse = this.chaseUSResponse;
		this.activeInvoice.chaseCAResponse = this.chaseCAResponse;
		this.activeInvoice.authNetUSResponse = this.authNetUSResponse;
		this.activeInvoice.globalPaymentsResponse = this.globalPaymentsResponse;
		this.activeInvoice.e_XactResponse = this.e_XactResponse;
		this.activeInvoice.velocityResponse = this.velocityResponse;
		this.activeInvoice.cyberSourceResponse = this.cyberSourceResponse;

		this._invoiceService.processPaymentResponse(this.activeInvoice).subscribe((response: any) => {
			this.processPayResponse(response);
			this.messageService.isBusy = false;
		}, (error: any) => {
			this.isProcessed = true;
			this.hasError = true;
			this.logFailedRequest(error);
			this.messageService.showAppError('Error!', error);
		});
	}

	private processPayResponse(data: any){
		this.hasError = false;
		this.isProcessed = false;
		this.activeInvoice = data;
		localStorage.setItem('activeInvoice', JSON.stringify(this.activeInvoice));

		if ((this.activeInvoice.paymentAccepted !== undefined && this.activeInvoice.paymentAccepted != null) || this.activeInvoice.invoiceTxnStatus == 1024) {
			if(this.activeInvoice.paymentAccepted == true) {
				this.router.navigate(['/pay-items', {key: this.activeInvoice.orderKey, invNum: this.activeInvoice.invoiceNumber, accepted: this.activeInvoice.paymentAccepted}]);
			} else {
				this.isProcessed = true;
			}
			this.messageService.isBusy = false;
		} else {
			this.isProcessed = true;
			this.hasError = true;
			this.messageService.showAppError('Error!', 'Sorry, this payment could not be processed. Please retain the invoice number, bank approval code, and date and time of transaction from the data below.');
			this.logFailedRequest('Unable to process pay response from transaction');
		}
	}

	private getResponseInvoice(key: string, invoiceNumber: string, amountPaid: number){
		this._invoiceService.getActiveInvoice(key, invoiceNumber, amountPaid).subscribe((response: any) => {
			this.messageService.isBusy = false;
			this.updateInvoice(response);
		}, (error: any) =>{
			this.isProcessed = true;
			this.hasError = true;
			this.messageService.showAppError('Error!', 'Sorry, this payment could not be processed. Please retain the invoice number, bank approval code, and date and time of transaction from the data below.');
			this.activeInvoice = new InvoiceModel();
			this.logFailedRequest(error);
		});
	}

	private getOpenEdgeOrder(orderRefNumber: string) {
		this._openEdgeService.getOpenEdgeOrder(orderRefNumber).subscribe((response: any) => {
			this.messageService.isBusy = false;
			this.updateInvoice(response);
		}, (error: any) => {
			this.isProcessed = true;
			this.hasError = true;
			this.messageService.showAppError('Error!', 'Sorry, this payment could not be processed. Please retain the invoice number, bank approval code, and date and time of transaction from the data below.');
			this.logFailedRequest(error);
		});
	}

	private logFailedRequest(error: any) {
		var errorMessage: string = '';
		try {
			console.log(error);
			if(error?.error?.detail) {
				errorMessage = error?.error?.detail;
			} else {
				errorMessage = JSON.parse(error._body).Message;
			}
		} catch (e) {
			errorMessage = error;
		}

		this._invoiceService.logFailedRequest(this.activeInvoice.orderKey, errorMessage, JSON.stringify(this.responseJson)).subscribe((response: any)=> {
			this.errorTracerId = response;
		});
	}
}